import { useState } from 'react';
import { Modal, Button, Input, Select } from '../common';
import { ROLE_META } from '../../utils/constants';
import { createUser } from '../../services/userService';

/**
 * Add User Modal
 * Admin/Sales Manager can create new users with specific roles
 */
export function AddUserModal({ isOpen, onClose, showToast, onUserCreated }) {
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    password: "",
    role: "marketer",
    phone: "",
    commission_per_deal: null,
  });
  const [submitting, setSubmitting] = useState(false);

  const updateField = (key, value) => {
    setFormData(prev => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.username || !formData.password) {
      showToast("يرجى ملء جميع الحقول المطلوبة", "error");
      return;
    }

    setSubmitting(true);
    try {
      const newUser = await createUser(formData);
      
      if (newUser) {
        showToast("✅ تم إنشاء الحساب بنجاح");
        
        // If parent provided callback, call it with new user
        if (onUserCreated) {
          onUserCreated(newUser);
        }
        
        // Reset form
        setFormData({
          name: "",
          username: "",
          password: "",
          role: "marketer",
          phone: "",
          commission_per_deal: null,
        });
        
        onClose();
      }
    } catch (err) {
      console.error('Error creating user:', err);
      showToast(err.message || '❌ فشل في إنشاء الحساب', 'error');
    } finally {
      setSubmitting(false);
    }
  };

  // Build role options from constants
  const roleOptions = Object.entries(ROLE_META)
    .filter(([key]) => key !== 'admin') // Admin created manually
    .map(([key, meta]) => ({
      value: key,
      label: meta.label, // Only Arabic label, no icon name
    }));

  return (
    <Modal 
      title="👤 مستخدم جديد" 
      isOpen={isOpen} 
      onClose={onClose}
      size="md"
    >
      <div style={{ direction: "rtl" }}>
        <Input
          label="الاسم الكامل"
          value={formData.name}
          onChange={e => updateField('name', e.target.value)}
          placeholder="سارة أحمد"
          required
        />

        <Input
          label="اسم المستخدم"
          value={formData.username}
          onChange={e => updateField('username', e.target.value)}
          placeholder="sara.ahmad"
          required
        />

        <Input
          label="كلمة المرور"
          type="password"
          value={formData.password}
          onChange={e => updateField('password', e.target.value)}
          placeholder="••••••••"
          required
        />

        <Input
          label="رقم الهاتف (اختياري)"
          type="tel"
          value={formData.phone}
          onChange={e => updateField('phone', e.target.value)}
          placeholder="+971 50 123 4567"
        />

        <Select
          label="الدور"
          value={formData.role}
          onChange={e => updateField('role', e.target.value)}
          options={roleOptions}
        />

        {(formData.role === 'marketer' || formData.role === 'rep') && (
          <Input
            label="العمولة لكل صفقة ناجحة (AED) - اختياري"
            type="number"
            value={formData.commission_per_deal || ''}
            onChange={e => updateField('commission_per_deal', parseFloat(e.target.value) || null)}
            placeholder={formData.role === 'marketer' ? '20' : '35'}
          />
        )}

        <div style={{ display: "flex", gap: 12, marginTop: 24 }}>
          <Button 
            onClick={handleSubmit} 
            disabled={submitting}
            style={{ flex: 1, justifyContent: "center" }}
          >
            {submitting ? "جاري الإنشاء..." : "إنشاء الحساب"}
          </Button>
          <Button 
            variant="secondary" 
            onClick={onClose}
            disabled={submitting}
            style={{ flex: 1, justifyContent: "center" }}
          >
            إلغاء
          </Button>
        </div>
      </div>
    </Modal>
  );
}
